export const languages = {
  en: "English",
  fr: "Français",
};

export const defaultLanguage = "en";

export const ui = {
  en: {
    theme: "Theme",
    language: "Language",
    system: "System",
    light: "Light",
    dark: "Dark",
    nav: {
      home: "Home",
      blog: "Blog",
      experience: "Experience",
      study: "Study",
      certificates: "Certificates",
      projects: "Projects",
      contact: "Contact",
    },
    searchLabel: "Search",
    searchPlaceholder: "Search pages, projects, posts, certificates...",
    searchClose: "Close",
    searchNoResults: "No results found.",
    searchTypePage: "Page",
    searchTypeProject: "Project",
    searchTypeBlog: "Blog",
    searchTypeCertificate: "Certificate",
    searchTypeExperience: "Experience",
    searchTypeStudy: "Study",
    homeTitle: "Hi !",
    homeIntro:
      "My name is Hamza, and I am a software engineer. I mostly work with and am interested in Java, JavaScript, TypeScript, and C++.",
    latestProjects: "Latest Projects",
    latestBlogPosts: "Latest Blog Posts",
    blogPosts: "Blog Posts",
    experience: "Experience",
    studyPath: "Study Path",
    certificates: "Certificates",
    projects: "Projects",
    projectFilters: "Project filters",
    projectFilterAll: "All",
    projectFilterEmpty: "No projects match this filter.",
    contact: "Contact",
    contactIntro:
      "Have a project, collaboration, or technical question in mind? Send me a note and I will get back to you as soon as I can.",
    contactEmailLabel: "Email",
    contactGithubLabel: "GitHub",
    contactEmailAction: "Write an email",
    contactGithubAction: "View profile",
    contactResponseTimeLabel: "Response time",
    contactResponseTime: "Usually within a few business days.",
    contactFormTitle: "Send a message",
    contactNameLabel: "Name",
    contactNamePlaceholder: "Your name",
    contactEmailPlaceholder: "you@example.com",
    contactSubjectLabel: "Subject",
    contactSubjectPlaceholder: "Project, collaboration, or question",
    contactMessageLabel: "Message",
    contactMessagePlaceholder: "Tell me a little about what you have in mind...",
    contactSubmit: "Send message",
    seeLess: "See less",
    seeAll: "See all",
    seeAllGithubPrefix: "See all (more on",
    seeAllGithubSuffix: ")",
    backProjects: "<- Projects",
    backBlog: "<- Blog",
    backCertificates: "<- Certificates",
    copyLink: "Copy link",
    linkCopied: "Copied",
    copyCode: "Copy code",
    codeCopied: "Copied",
    projectNotFound: "Project not found.",
    blogNotFound: "Blog post not found.",
    certificateNotFound: "Certificate not found.",
    certificateImageMissing: "Certificate image not added yet.",
    certificateAltSuffix: "certificate",
    private: "private",
    technologiesUsed: "Technologies used:",
    error404: "Oops! The page you're looking for doesn't exist.",
    minRead: "min read",
    previousImage: "Previous image",
    nextImage: "Next image",
    chooseImage: "Choose image",
    showImage: "Show image",
    projectImage: "Project image",
  },
  fr: {
    theme: "Theme",
    language: "Langue",
    system: "Système",
    light: "Clair",
    dark: "Sombre",
    nav: {
      home: "Accueil",
      blog: "Blog",
      experience: "Expérience",
      study: "Parcours",
      certificates: "Certificats",
      projects: "Projets",
      contact: "Contact",
    },
    searchLabel: "Recherche",
    searchPlaceholder: "Rechercher des pages, projets, articles, certificats...",
    searchClose: "Fermer",
    searchNoResults: "Aucun résultat trouvé.",
    searchTypePage: "Page",
    searchTypeProject: "Projet",
    searchTypeBlog: "Blog",
    searchTypeCertificate: "Certificat",
    searchTypeExperience: "ExpÃ©rience",
    searchTypeStudy: "Parcours",
    homeTitle: "Salut !",
    homeIntro:
      "Je m'appelle Hamza et je suis ingénieur logiciel. Je travaille surtout avec Java, JavaScript, TypeScript et C++, et ce sont aussi les technologies qui m'intéressent le plus.",
    latestProjects: "Derniers projets",
    latestBlogPosts: "Derniers articles",
    blogPosts: "Articles",
    experience: "Expérience",
    studyPath: "Parcours d'études",
    certificates: "Certificats",
    projects: "Projets",
    projectFilters: "Filtres de projets",
    projectFilterAll: "Tout",
    projectFilterEmpty: "Aucun projet ne correspond à ce filtre.",
    contact: "Contact",
    contactIntro:
      "Vous avez un projet, une collaboration ou une question technique en tête ? Envoyez-moi un message et je vous répondrai dès que possible.",
    contactEmailLabel: "Email",
    contactGithubLabel: "GitHub",
    contactEmailAction: "Écrire un email",
    contactGithubAction: "Voir le profil",
    contactResponseTimeLabel: "Délai de réponse",
    contactResponseTime: "Généralement sous quelques jours ouvrés.",
    contactFormTitle: "Envoyer un message",
    contactNameLabel: "Nom",
    contactNamePlaceholder: "Votre nom",
    contactEmailPlaceholder: "vous@example.com",
    contactSubjectLabel: "Sujet",
    contactSubjectPlaceholder: "Projet, collaboration ou question",
    contactMessageLabel: "Message",
    contactMessagePlaceholder: "Expliquez-moi brièvement ce que vous avez en tête...",
    contactSubmit: "Envoyer le message",
    seeLess: "Voir moins",
    seeAll: "Voir tout",
    seeAllGithubPrefix: "Voir tout (plus sur",
    seeAllGithubSuffix: ")",
    backProjects: "<- Projets",
    backBlog: "<- Blog",
    backCertificates: "<- Certificats",
    copyLink: "Copier le lien",
    linkCopied: "Copié",
    copyCode: "Copier le code",
    codeCopied: "Copié",
    projectNotFound: "Projet introuvable.",
    blogNotFound: "Article introuvable.",
    certificateNotFound: "Certificat introuvable.",
    certificateImageMissing: "L'image du certificat n'a pas encore été ajoutée.",
    certificateAltSuffix: "certificat",
    private: "privé",
    technologiesUsed: "Technologies utilisées :",
    error404: "Oups ! La page que vous cherchez n'existe pas.",
    minRead: "min de lecture",
    previousImage: "Image précédente",
    nextImage: "Image suivante",
    chooseImage: "Choisir une image",
    showImage: "Afficher l'image",
    projectImage: "Image du projet",
  },
};

export function getTranslations(language) {
  return ui[language] || ui[defaultLanguage];
}

export function localizeField(item, field, language) {
  if (!item) {
    return "";
  }

  return language === "fr" && item[`${field}Fr`] ? item[`${field}Fr`] : item[field];
}

export function localizeBody(item, language) {
  if (!item) {
    return [];
  }

  return language === "fr" && item.bodyFr ? item.bodyFr : item.body;
}

const monthTranslations = {
  fr: {
    jan: "janv.",
    feb: "févr.",
    mar: "mars",
    apr: "avr.",
    may: "mai",
    jun: "juin",
    jul: "juil.",
    aug: "août",
    sep: "sept.",
    oct: "oct.",
    nov: "nov.",
    dec: "déc.",
  },
};

const linkLabelTranslations = {
  fr: {
    "live demo": "Démo live",
  },
};

export function localizeDateLabel(value, language) {
  if (!value || language !== "fr") {
    return value || "";
  }

  return value
    .replace(
      /\b(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\.?/gi,
      (match) => monthTranslations.fr[match.replace(".", "").toLowerCase()] || match
    )
    .replace(/\bPresent\b/g, "Présent");
}

export function localizeLinkLabel(label, language) {
  if (!label || language !== "fr") {
    return label;
  }

  return linkLabelTranslations.fr[label.toLowerCase()] || label;
}
